export const USER_TABLE_COLUMNS = [
    { title: '用户唯一ID（memcard）', dataIndex: 'memCard', key: 'memCard', width: 150, fixed: 'left' },
    { title: '用户昵称', dataIndex: 'memNickname' },
    { title: '真实姓名', dataIndex: 'memRealName' },
    { title: '性别', dataIndex: 'memSex' },
    { title: '手机号', dataIndex: 'memMobile' },
    { title: '邮箱', dataIndex: 'memEmail' },
    { title: '用户身份', dataIndex: 'memIdentity' },
    { title: '会员类别', dataIndex: 'memType' },
    { title: '单位名称', dataIndex: 'memUnit' },
    { title: '科室', dataIndex: 'memOffice' },
    { title: '职务', dataIndex: 'memPost' },
    { title: '职称', dataIndex: 'memJobtitle' },
    { title: '注册端口', dataIndex: 'memDeviceType' },
    { title: '用户状态', dataIndex: 'memState' },
    { title: '注册时间', dataIndex: 'memRegistTime' },
    { title: '认证审核时间', dataIndex: 'memExamineTime' },
    { title: '最后登录时间', dataIndex: 'memLastestLoginTime' },
];

export function getColumnVisibilityAfterToggleAll(columns, checked) {
    return columns.map((item, index) => ({
        ...item,
        checked: checked ? true : index === 0,
    }));
}

export function buildUserTableColumns(showColumn) {
    return USER_TABLE_COLUMNS.map((column, index) => ({
        ...column,
        className: showColumn[index]?.checked ? '' : 'not-show',
    }));
}
